import classnames from 'classnames';
import PropTypes from 'prop-types';
import React from 'react';
import { useDispatch } from 'react-redux';

import { pushParams } from 'dpl/actions/query_params';
import Button from 'dpl/common/design_system/Button';
import { SIGNUP_FORM_TYPES } from 'dpl/shared/constants/shared';

export default function MobileAuthButtons({ className }) {
  const dispatch = useDispatch();

  function redirect(param) {
    dispatch(pushParams({ direct_signup: param }, { hash: true }));
  }

  return (
    <div className={classnames('MobileAuthButtons flex gap-8', className)}>
      <Button
        variant="outline"
        className="w-100 pv3"
        onClick={() => redirect(SIGNUP_FORM_TYPES.LOGIN)}
      >
        Log in
      </Button>
      <Button
        variant="primary"
        className="w-100 pv3"
        onClick={() => redirect(SIGNUP_FORM_TYPES.SIGNUP_INTRO)}
      >
        Sign up
      </Button>
    </div>
  );
}

MobileAuthButtons.propTypes = {
  className: PropTypes.string
};

MobileAuthButtons.defaultProps = {
  className: null
};
